import React, { useState } from 'react';
import { SxStyle } from '../../../../../types';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';

const styles: SxStyle = {
  title: {
    height: '42px',
    backgroundColor: 'background.default',
    display: 'flex',
    alignItems: 'center',
    padding: 2,
    borderBottom: '1px solid',
    borderColor: 'shades.p15',

    '&:first-child': {
      borderTop: '1px solid',
      borderColor: 'shades.p15',
    },
  },
};

interface Props {
  title: string;
  showToggle?: boolean;
  enableToggle?: boolean;
  onToggle?: (checked: boolean) => void;
  children: React.ReactNode;
}

const ColorSection = ({ title, showToggle, enableToggle, onToggle, children }: Props) => {
  const [enable, setEnable] = useState(enableToggle || false);

  const handleToggle = (checked: boolean) => {
    setEnable(checked);
    onToggle && onToggle(checked);
  };

  return (
    <>
      <Stack sx={styles.title} direction="row" justifyContent="space-between">
        <Typography variant="overline">{title}</Typography>
        {showToggle && (
          <Switch
            size="small"
            checked={enable}
            onChange={(event, checked) => {
              onToggle && handleToggle(checked);
            }}
          />
        )}
      </Stack>
      {children}
    </>
  );
};

export default ColorSection;
